"use strict";

angular.module('app').factory('ShopModel', function($routeParams, $timeout, $location, $injector, $rootScope) {
    function Shop(model, seoName) {
        var title = model.title + ' ' + seoName + ' in ' + model.area + ', ' + model.country + ' | PADI Travel',
            description = 'Explore the ' + seoName.toLocaleLowerCase() + ' ' + model.title + ' in ' + model.area + ', ' + model.country + '. Reviews, ratings, photos, and prices. Easily book your next dive holiday online.';

        this._model = model;
        this._shopType = null;
        this.seo = {
            title: model.metaTitle || title,
            description: model.metaDescription || description,
            image: model.backgrounds ? model.backgrounds.DOSliderDesktop : null,
            kind: 'product'
        };
        this._data = {};


        if (this._model.kindVerbose === "Dive center") {
            this._shopType = 'diveCenter';
        } else if (this._model.kindVerbose === "Dive resort") {
            this._shopType = 'diveResort';
        }
    }

    Shop.prototype.info = function() {
        return this._model;
    };

    Shop.prototype.recentlyViewed = function() {
        var recently = $injector.get('RecentlyViewed'),
            route = $injector.get('$routeParams');

        if (!this._model.isRecentlyViewed) {
            recently.add({
                item_type: 'Shop',
                item_slug: route.slug
            });
        }

        return this;
    };

    Shop.prototype.setMainGTM = function() {
        var GTM = $injector.get('GTM');

        GTM.variables({
            operator_id: this._model.id,
            operator_name: this._model.title,
            operator_type: this._model.kindVerbose,
            operator_area: this._model.area,
            operator_country: this._model.country,
            operator_rating_average: this._model.rating
        });

        return this;
    };

    /**
     * Set up map config for Leaflet;
     * @return {Object} Returned configuration for Leaflet.
     */

    Shop.prototype.mapConfig = function() {
        return {
            center: {},
            defaults: {
                scrollWheelZoom: false
            },
            layers: {
                baselayers: {
                    mapbox_light: {
                        name: 'Mapbox Diviac',
                        url: '//api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
                        type: 'xyz',
                        layerOptions: {
                            apikey: 'pk.eyJ1IjoiYW5pb3Jrb3dhIiwiYSI6ImViNmUyOGFkMzExZThkMjIzNTdhMWVlYThjYmZmOGNjIn0.VpyrpaL2NpwHDCQ83qt93w#8/12.214/-84.963',
                            mapid: 'aniorkowa.mpe29hcd',
                            showOnSelector: false
                        }
                    }
                }
            }
        };
    };

    /**
     * Set up date from sessionStorage to date-picker;
     * @return {Object} Returned date-picker data and additional data for date-picker works.
     */

    Shop.prototype.setDate = function() {
        var localStorageService = $injector.get('diviacLocalStorage'),
            sessionDate = localStorageService.get('date');

        this.date = sessionDate || null;
        this.sessionStorage = localStorageService;

        if (sessionDate && sessionDate.length) {
            this._data.from = sessionDate[0] ? moment(sessionDate[0]).format('YYYY-MM-DD') : null;
            this._data.to = sessionDate[1] ? moment(sessionDate[1]).format('YYYY-MM-DD') : null;

            this._data.fromFullDate = sessionDate[0];
            this._data.toFullDate = sessionDate[1];

            this._data.sidebarFilterDate = {
                month: sessionDate[0] ? moment(sessionDate[0]).format("MMMM") : null,
                startDate: sessionDate[0] ? moment(sessionDate[0]).format('YYYY-MM-DD') : null,
                endDate: sessionDate[1] ? moment(sessionDate[1]).format('YYYY-MM-DD') : null,
                year: sessionDate[0] ? (new Date(sessionDate[0])).getFullYear() : null
            };

            this._data.filterDate = this._data.sidebarFilterDate;

            //this.getProducts(this._data.sidebarFilterDate);
        } else {
            this._data.showDetail = true;
        }

        angular.extend(this._data, this.setDatesFromCart());

        return this._data;
    };

    /**
     * Set up dates based on on cart.
     * @return {Object} Set dates based on cart. If we have any products in cart we use this product dates to set up
     * our date-picker and filter product via using this dates. Using recursion this.setDate(callback) to set up all
     * needed data for sidebar and product section.
     */

    Shop.prototype.setDatesFromCart = function(callback) {
        var cart = $injector.get('cartService'),
            products = cart.getProducts();

        if (products.length && !this.date) {

            var dateFrom = products[0].selectedProduct.dateFrom,
                dateTo = products[0].selectedProduct.dateTo;


            _.each(products, function(val) {
                if (val.kind === 10) {
                    dateFrom = val.dateFrom;
                    dateTo = val.dateTo;
                }
            });

            if (!dateTo || !dateTo) {
                return true;
            }

            this._data.from = moment(dateFrom).format('L');
            this._data.to = dateTo ? moment(dateTo).format('L') : moment(dateFrom).add(1, 'days').format('L');

            this._data.fromFullDate = dateFrom;
            this._data.toFullDate = dateTo ? dateTo : moment.utc(dateFrom).add(1, 'days').format();
            this._data.showDetail = false;

            this.sessionStorage.set('date', [this._data.fromFullDate, this._data.toFullDate]);
            this.date = [this._data.fromFullDate, this._data.toFullDate];

            this.setDate();
        }

        return this._data;

    };

    /**
     * Get prepared photos for current DO type.
     * @return {Object} Prepared photo object where we have bad and good quality photos.
     * */
    Shop.prototype.getPhotos = function() {
        var photos = $injector.get('DiveOperator'),
            obj = {},
            _this = this;

        if (!_.isEmpty(_this.info.backgrounds)) {
            _this.info.background = {
                title: 'Main photo',
                id: 880055355, // randomed number
                thumbnails: {
                    DOSliderDesktop: _this.info.backgrounds.DOSliderDesktop,
                    DOSliderTabletLand: _this.info.backgrounds.DOSliderTabletLand,
                    DOSliderTabletPort: _this.info.backgrounds.DOSliderTabletPort,
                    DOSliderMobileLand: _this.info.backgrounds.DOSliderMobileLand,
                    DOSliderMobilePort: _this.info.backgrounds.DOSliderMobilePort
                }
            };
        }

        return photos[this._shopType + 'Photos']().then(function(data) {
            obj.slidersImages = data.groupedPhotos;
            obj.allPhotos = data.allPhotos;

            var screenWidth = $(window).innerWidth(),
                goodQuality = screenWidth - (screenWidth * 0.35);

            _.each(obj.slidersImages, function(val) {
                val.badImages = [];
                val.goodImages = [];

                _.each(val, function(v) {
                    if (v.width < goodQuality) {
                        val.badImages.push(v);
                    } else {
                        val.goodImages.push(v);
                    }
                });
            });
            // If shop have a background image -> then we need to add this image on first position of photos array;

            if (_this.info.background) {
                obj.allPhotos.unshift(_this.info.background);
            }

            // If we don't have any photos - we need to show message for user. Because users need to know, why this shit is happen;
            if (data.allPhotos.length === 0) {
                obj.noPhotos = true;
            }

            return obj;
        });
    };


    /**
     *
     * @param price {Number} price for one product.
     * @returns {number} Recalcultated price based on number of nights.
     */
    Shop.prototype.generateRoomPrice = function(price) {
        var utils = $injector.get('utils'),
            numberOfDays = 1;

        if (this.from && this.to) {
            numberOfDays = utils.dayDiff(this.fromFullDate, this.toFullDate);

            if (numberOfDays < 1) {
                numberOfDays = 1;
            }

            this.numberOfDays = numberOfDays;
        }

        return price * numberOfDays;
    };

    /**
     *
     * @param cabin {Object} Current product. We need to use product variants for founding needed variant.
     * @param option {Object} This options used for getting needed product variant. We are using this option combinations
     * to select different variants.
     */
    Shop.prototype.filterRoomPrice = function(cabin, option) {
        var _this = this;
        _.each(cabin.variants, function(cab) {
            if (cab.option1_value == option.occupancyType.option1_value) {
                cabin.filteredId = cab.id;
                cabin.filteredPrice = _this.generateRoomPrice(cab.price) * option.qty;
                cabin.selectedQty = option.qty;
            }
        });
    };

    /**
     *
     * @param {Object} date Not required param. Used for filtering products;
     *
     * @return {Object} All products in this shop.
     */
    Shop.prototype.getProducts = function(date, disableChange, filter, callback, url, revert) {
        var _this = this,
            DiveOperator = $injector.get('DiveOperator'),
            utils = $injector.get('utils'),
            GTM = $injector.get('GTM'),
            q = $injector.get('$q'),
            $timeout = $injector.get('$timeout');

        if (!date) {
            date = _this.filterDate || {};
        }

        if (this.shopType && this.shopType !== 'diveResort' && this.shopType !== 'liveaboard') {
            date.kind = null;
            // date.from = null;
            // date.to = null;
        }
        
        _this.priceLoading = true;

        var analyticProducts = {
            detail: {
                product: []
            }
        };

        $timeout(function() {
            if (window.fbq) {
                fbq('track', 'ViewContent', {
                    content_ids: [_this.info.id],
                    content_type: 'product',
                    value: _this.info.minimalPrice,
                    currency: _this.info.currency
                });
            }
        }, 4000);
        var k = 0;

        if (_this.shopType === 'diveResort') {
            _this.roomsLoading = true;

            q.all([
                DiveOperator.getRooms(date),
                DiveOperator.getSleepPackages(date)
            ]).then(function(data) {
                _this.rooms = data[0];
                _this.sleepPackages = data[1];
                _this.roomsLoading = false;

                _.each(data, function(products) {
                    _.each(products, function(product) {
                        analyticProducts.detail.product.push({
                            name: product.title,
                            id: product.id,
                            price: product.price,
                            brand: _this.info.title,
                            category: _this.info.kindVerbose
                        });
                    });
                });

                k++;

                if (k === 2 && callback) {
                    callback();
                }


                GTM.products(null, analyticProducts);
            });
        }

        DiveOperator.getProducts(date).then(function(data) {
            _this.priceLoading = false;
            _this.divingProducts = data;
            _this.courses = _.filter(data, {
                kind: 30
            });
            _this.dives = _.reject(data, {
                kind: 30
            });

            if (callback) {
                k++;
                if (_this.shopType === 'diveResort' && k === 2) {
                    callback();
                } else if (_this.shopType !== 'diveResort') {
                    callback();
                }
            }

            _.each(data, function(product) {
                analyticProducts.detail.product.push({
                    name: product.title,
                    id: product.id,
                    price: product.price,
                    brand: _this.info.title,
                    category: _this.info.kindVerbose
                });
            });

            GTM.products(null, analyticProducts);
        });
    };
    /**
     *
     * @param cabinID {Number} Product id;
     * @param increase {Number} Do we need to increase number of products, that we are adding to cart (For example it's works
     * for rooms. We can select number of days, but our system isn't support dates on checkout, so we need to increase number of
     * products).
     * @param recalculatePrice {Boolean} Do we need to recalculate price of current product
     * @param qty {Number} Products quantity.
     */
    Shop.prototype.addProductToCart = function(cabinID, increase, recalculatePrice, qty) {
        var GTM = $injector.get('GTM'),
            utils = $injector.get('utils'),
            localStorageService = $injector.get('diviacLocalStorage'),
            cartService = $injector.get('cartService'),
            diviacLocalStorage = $injector.get('diviacLocalStorage'),
            chosenProduct,
            _this = this;

        qty = qty || 1;

        _.each(_this.cabins, function(product) {
            if (product.variants && product.variants.length) {
                _.uniq(product.variants, function(cabin) {
                    if (cabin.id == cabinID) {
                        cabin = _.clone(cabin);

                        if (recalculatePrice) {
                            cabin.priceForNight = cabin.price;
                            cabin.pricePerOneProduct = _this.generateRoomPrice(cabin.price);
                            cabin.price = cabin.pricePerOneProduct * qty;
                            cabin.qty = qty;
                            cabin.dateFrom = _this.fromFullDate;
                            cabin.dateTo = _this.toFullDate;
                            product.dateFrom = _this.fromFullDate;
                            product.dateTo = _this.toFullDate;
                        } else {
                            cabin.pricePerOneProduct = cabin.price;
                            cabin.price = cabin.pricePerOneProduct * qty;
                            cabin.qty = qty;
                            cabin.dateFrom = _this.fromFullDate;
                        }

                        cabin.shopKindVerbose = _this.info.kindVerbose;

                        product.selectedProduct = _.cloneDeep(cabin);
                        // for rooms
                        if (increase) {
                            product.selectedProduct.increase = increase;
                        }
                        chosenProduct = _.cloneDeep(product);
                    }
                });
            } else {
                if (cabinID == product.id) {
                    var cab = {
                        pricePerOneProduct: product.price,
                        price: product.price * qty,
                        qty: qty,
                        dateToFullDate: _this.fromFullDate,
                        currency: product.currency
                    };

                    product.selectedProduct = cab;

                    chosenProduct = _.cloneDeep(product);
                }
            }
        });
        if (chosenProduct) {
            delete chosenProduct.uniqueProducts;
            delete chosenProduct.variants;
            delete chosenProduct.selectedProduct.occupancy;
            delete chosenProduct.selectedProduct.packageType;
            delete chosenProduct.occupancy;
            delete chosenProduct.packageType;

            if (chosenProduct.kind != 10 && chosenProduct.kind != 20) {
                chosenProduct.dateFrom = null;
            }

            $rootScope.order = false;

            if (window.localStorage['productInCart']) {
                var cart = JSON.parse(window.localStorage['productInCart']);

                GTM.variables({
                    cart_last_item_used: chosenProduct
                });

                // group item in the cart
                var addToCart = true;
                _.each(cart, function(el, index) {
                    if (el.selectedProduct.dateFrom == chosenProduct.selectedProduct.dateFrom &&
                        el.selectedProduct.dateTo == chosenProduct.selectedProduct.dateTo &&
                        el.selectedProduct.id == chosenProduct.selectedProduct.id) {

                        el.selectedProduct.qty = parseInt(el.selectedProduct.qty) + parseInt(chosenProduct.selectedProduct.qty);
                        el.selectedProduct.price = el.selectedProduct.pricePerOneProduct * el.selectedProduct.qty;
                        addToCart = false;
                    }
                });

                // if item grouped we haven't add product to cart
                if (addToCart) {
                    cart.push(chosenProduct);
                }

                window.localStorage['productInCart'] = JSON.stringify(cart);
            } else {
                window.localStorage['productInCart'] = JSON.stringify([chosenProduct]);
            }
            _this.carts = JSON.parse(window.localStorage['productInCart']);
            _this.cartTotalPrice();

            if (utils.isMobile()) {
                $rootScope.showNotify('Item was successfully added to your cart');
            }

            if (parseInt(chosenProduct.kind) === 10) {
                _this.from = moment(chosenProduct.dateFrom).format('L');
                _this.to = moment(chosenProduct.dateTo).format('L');

                _this.fromFullDate = chosenProduct.dateFrom;
                _this.toFullDate = chosenProduct.dateTo;

                var date = [_this.fromFullDate, _this.toFullDate];

                localStorageService.set('date', date);

                _this.sidebarFilterDate = {
                    month: moment(chosenProduct.dateFrom).format("MMMM"),
                    startDate: moment(chosenProduct.dateFrom).format('YYYY-MM-DD'),
                    endDate: moment(chosenProduct.dateTo).format('YYYY-MM-DD'),
                    year: (new Date(chosenProduct.dateFrom)).getFullYear()
                };
                _this.filterDate = _this.sidebarFilterDate;

                _this.showDetail = false;
            }

            var analyticProducts = {
                    currencyCode: 'USD',
                    add: {
                        products: []
                    }
                },
                variants = [];

            _.each(_this.carts, function(val) {
                analyticProducts.add.products.push({
                    title: val.title,
                    id: val.id,
                    price: val.selectedProduct.pricePerOneProduct,
                    brand: val.vendor,
                    category: val.selectedProduct.shopKindVerbose,
                    quantity: val.selectedProduct.qty
                });

                var qty = val.selectedProduct.qty;

                if (val.kind == 20) {
                    qty = qty * utils.dayDiff(val.selectedProduct.dateFrom, val.selectedProduct.dateTo);
                }

                variants.push({
                    variant: val.selectedProduct.id,
                    quantity: qty
                });
            });

            GTM.products('cart_product_add', analyticProducts);

            cartService.getDueNow(_this, variants);

            GTM.variables({
                'user_cart_total_items_added': _this.carts.length
            });
        }
    };

    /**
     * Just seo tags
     */
    Shop.prototype.generateSeoTags = function() {
        var seo = $injector.get('SeoService');

        seo.generateMetaTags(this.seo.title, this.seo.description, this.seo.image, this.seo.kind);

        return this;
    };


    Shop.prototype.getOccupancyIcon = function(title) {
        var lowerTitle = title.toLowerCase();

        if (lowerTitle.match('single')) {
            return 1;
        } else if (lowerTitle.match('double')) {
            return 2;
        } else if (lowerTitle.match('shared')) {
            return 4;
        } else {
            return 3;
        }
    };

    return {
        shop: Shop
    };
});